import React from 'react';
import ConfirmDeactivationIcon from '../../svgs/ConfirmDeactivationIcon';
import ModalFormComp from '../ModalFormComp';
import StyledButton from '../StyledButton';
import './ErrorPermissionModalComp.scss';

interface IErrorPermissionModalComp{
  closeModal?:any;
}
const ErrorPermissionModalComp = ({ closeModal }:IErrorPermissionModalComp) => (
  <ModalFormComp
    removeTitle
    modalType="error_permission__modal"
    closeModal={closeModal}
    cancleDivWidth="100%"
  >
    <div className="error_icon_cover"><ConfirmDeactivationIcon /></div>
    <div className="error_content_div_cover">Permission Denied</div>
    <div className="error_sub_content_div_cover">You do not have permission to perform this operation</div>
    <div className="close_button_cover">
      <StyledButton name="Okay" backgroundColor="rgba(82, 59, 159, 1)" padding="10px 26px" color="white" border="none" fontSize="12px" borderRadius="4px" onClick={closeModal} />
    </div>
  </ModalFormComp>
);
export default ErrorPermissionModalComp;
